import React, { CSSProperties, useEffect, useState } from "react";
import styles from "./styles/displaystyle.module.css";
import apiService from "../../services/apiService";
import { RaceDTO } from "../../interfaces/RaceDTO";
import EventOperations from "../../services/EventOperations";
import { TimeDTO } from "../../interfaces/TimeDTO";
import { GetHeatName } from "../results/resultviews/ResultStage";
import DisplayResults from "./DisplayResults";
import DisplayModalSettings from "./DisplayModalSettings";
import { useDisplays } from "../../services/displayservices/DisplayProvider";
import DisplayInfo from "./displayinfo/DisplayInfo";
interface Props {
  raceid: number | null;
}
export const DisplayView = ({ raceid }: Props) => {
  const [race, setRace] = useState<RaceDTO | null>(null);
  const [raceData, setRaceData] = useState<EventOperations | null>(null);
  const [isRaceMode,setIsRaceMode] = useState<boolean>(true);
  const [showModal,setShowModal] = useState<boolean>(false);
  const {display,getDisplayProperty,getDisplays} = useDisplays();
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check if Ctrl and Shift are held down and if the 'E' key is pressed
      if (event.ctrlKey && event.shiftKey && event.key === 'E') {
        // shortCutPress();+
        if (!showModal){
          setShowModal(true);
        }
      }
    };
    getDisplays();
    // Add event listener
    document.addEventListener('keydown', handleKeyDown);

    // Remove event listener on cleanup
    return () => document.removeEventListener('keydown', handleKeyDown);
  },[]);

  useEffect(() => {
    // console.log(raceid, "Result ", " ava")
    if (raceid !== null) {
      const fetchData = async () => {
        // try {
        const result = await apiService.get<RaceDTO>(
          "/GetRaceMini/" +
            raceid +
            "?ApiKey=#apikey#&GetFields=TimePass&GetFields=Athletes&TimingProvider=0a9afd9be94c9f567d86fa48c918bcd9"
        );
        // console.log(JSON.stringify(result));
        let EvOP: EventOperations = new EventOperations(result);
        EvOP.startConnection();
        setRaceData(EvOP);
        document.title = "CTRL+shift+e";
        const maxKey = Math.max(...Object.keys(EvOP.TimeScroll).map(Number));
      };
      fetchData();
    } else {
      if (raceData !== null) {
        raceData.stopConnection();
      }
    }

    return () => {
      if (raceData !== null)
      {
        raceData.stopConnection();
      }
    }
  }, [raceid]);
 
  const resMode = (inp: boolean) => {
    setIsRaceMode(inp);
  };
  const modalClose = () => {
    setShowModal(false);
  }
  const getBoxSize = ():CSSProperties => {
    let dispWid = getDisplayProperty("Width");
    let dispHei = getDisplayProperty("Height");
    let dispMargT = getDisplayProperty("MarginTop");
    let dispMargL = getDisplayProperty("MarginLeft");
    let dispBack = getDisplayProperty("Backgroundcolor")
    let cs:CSSProperties;
    if (dispHei === null || dispWid === null){
      cs = {
        
      }
    }
    else{
      cs = {
        height: dispHei + "px",
        width: dispWid + "px",
        marginTop: dispMargT + "px",
        marginLeft: dispMargL + "px",
        backgroundColor: dispBack,

      }
    }

    return cs;
  }


  if (raceData === null) {
    return <></>;
  }

  return (
    <div className={styles.displaybox} style={getBoxSize()}>
     
      <DisplayResults
        race={raceData.eventData}
        scroll={raceData.TimeScroll}
        resultmode={resMode}
      />
      <DisplayInfo showInfo={isRaceMode} />
      {showModal ? <DisplayModalSettings onExit={modalClose} /> : <></>}
    </div>
  );
};
